import { pipe } from 'fp-ts/lib/pipeable'
import { Decoder } from 'io-ts'

export const withDecoder = <A>(codec: Decoder<unknown, A>) => (payload: unknown) => pipe(payload, codec.decode)
